module.exports = __webpack_public_path__ + "img/img_stgl3.b5c13733.png";